module.exports = __webpack_public_path__ + "static/plaquette-9ff751acc7e1f3dd227ef1392fa79a53.png";